import * as Yup from "yup";

export const signUpSchema = Yup.object({
  Name: Yup.string().min(2).max(25),
  Email: Yup.string().email(),
  Mobile: Yup.number()
});